module.exports = __webpack_public_path__ + "466fa815da02cb3f09b42cbd1d878df4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/medias/images/computer.png
// module id = 874
// module chunks = 3